export const Directories = Object.freeze({
  Images: "../img",
  Videos: "../videos",
});

export const DEFAULT_IMAGE = "./banner.png";
export const DEFAULT_VIDEO = "./racing.mp4";
export const DEFAULT_FONT_TYPE = "/ConcertOne-Regular.ttf";
